import React, { Component }  from 'react';
import GoogleMapReact from 'google-map-react';
import Marker from './live/Marker';
import Axios from 'axios'
import InfoBox from './live/InfoBox.js'
 
const coords = {
  lat: -37.320987, 
  lng: -59.131708
};

// 'AIzaSyDLI-AHgN9wfMw05jFYgvGczKHRFPw7rjc'
// 'AIzaSyBnnHpwCHxuiZ4GUKU1-g0vAeEcNNSipW4'
 
class Main extends Component {
   
  constructor(props) {
	super(props);
	this.state = { 'userStates': [], 'ready': false, 'selected': null }
  };
   
  onMapCreated(map) {
    map.setOptions({
      disableDefaultUI: true
    });
  };
 
  componentDidMount() {
	this.loadData();
	this.timer = setInterval(() => this.loadData(), 10000);
  };
	
  onDragEnd(e) {
  };
 
  onCloseClick() {
  };
 
  onClick(e) {
  };
 
  loadData() {
	Axios.get("https://si.isistan.unicen.edu.ar/asistan/api/admin/live")
	.then(response => {
	  this.setState({'userStates': response.data, 'ready': this.state.ready, 'selected': this.state.selected });
    })
	.catch(function (error) {
       console.log(error);
    });
  };
  
  handleApiLoaded() {
	this.setState({'userStates': this.state.userStates, 'ready': true, 'selected': this.state.selected});
  };
  
  clickOnMarker(userState) { 
	this.setState({'userStates': this.state.userStates, 'ready': true, 'selected': userState});
  };

  render() {
	  
	var infoBox = null;
	if (this.state.selected != null)
		infoBox = <InfoBox userState={this.state.selected} />
	
    return (
	  <div style={{ height: '100%', width: '100%' }}>
		  <GoogleMapReact
		    bootstrapURLKeys={{ 'key': 'AIzaSyBnnHpwCHxuiZ4GUKU1-g0vAeEcNNSipW4' }}
			defaultCenter={{lat: coords.lat, lng: coords.lng}}
			defaultZoom={12}
			yesIWantToUseGoogleMapApiInternals
			onGoogleApiLoaded={() => { this.handleApiLoaded(); }}>
					  
			{ this.state.ready && this.state.userStates.map((userState,index) => (
				<Marker
					userState={userState}
					key={userState.userId}
					lat={userState.location.latitude}
					lng={userState.location.longitude}
					onClick={(data) => { this.clickOnMarker(data) }}
					color="blue"
				/>
			))}
			
		  </GoogleMapReact>
		  
		  			
		  { infoBox }
	  </div>
    );
  }
 
};

export default Main;